/**
 * 格式化工具函数
 */
export const formatDate = (date: string | Date, _format: string = 'YYYY-MM-DD'): string => {
  // 暂未按 _format 格式化，统一使用本地日期格式
  return new Date(date).toLocaleDateString()
}

export const formatNumber = (num: number, decimals: number = 2): string => {
  return num.toFixed(decimals)
}

export const formatBytes = (bytes: number, decimals: number = 2): string => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
}

/**
 * 学习时长（秒）按大小显示：满 1 小时为 "X 小时 Y 分"，否则 "Y 分钟"；缺失值显示 "—"
 */
export const formatStudyDuration = (seconds: number | null | undefined): string => {
  if (seconds == null || !Number.isFinite(seconds)) return '—'
  const totalMinutes = Math.floor(seconds / 60)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return hours > 0 ? `${hours} 小时 ${minutes} 分` : `${minutes} 分钟`
}
